<template>
  <q-item
    clickable
    @click="$emit('edit', index)"
  >
    <q-item-section>
      <q-item-label
        class="module-name"
        style="max-width: 600px;"
        :class="{ 'text-grey-5 text-italic': !item.text }"
      >
        {{ item.text || '(empty item)' }}
      </q-item-label>

      <div
        v-if="hasAnyRequirement"
        class="row items-center q-gutter-xs q-mt-xs"
      >
        <q-chip
          v-if="item.is_required"
          dense
          size="sm"
          color="grey-3"
          text-color="grey-9"
          icon="mdi-asterisk"
          label="Required"
        />
        <q-chip
          v-if="item.requires_photo"
          dense
          size="sm"
          color="blue-grey-1"
          text-color="blue-grey-9"
          icon="mdi-camera"
          label="Photo"
        />
        <q-chip
          v-if="item.requires_invoice"
          dense
          size="sm"
          color="blue-grey-1"
          text-color="blue-grey-9"
          icon="mdi-file-document-outline"
          :label="invoiceChipLabel"
        />
        <q-chip
          v-if="item.requires_quotation"
          dense
          size="sm"
          color="blue-grey-1"
          text-color="blue-grey-9"
          icon="mdi-file-document-edit-outline"
          :label="quotationChipLabel"
        />
        <q-chip
          v-for="form in (item.required_forms || [])"
          :key="'form-' + form.id"
          dense
          size="sm"
          color="blue-grey-1"
          text-color="blue-grey-9"
          icon="mdi-clipboard-text-outline"
          :label="form.title"
        />
      </div>

      <q-item-label
        v-if="errorMessage"
        caption
        class="text-red-8"
      >
        {{ errorMessage }}
      </q-item-label>
    </q-item-section>

    <q-item-section side class="q-ml-sm">
      <div>
        <q-btn
          dense
          flat
          round
          icon="mdi-pencil"
          @click.stop="$emit('edit', index)"
        >
          <q-tooltip>Edit</q-tooltip>
        </q-btn>

        <q-btn
          dense
          flat
          round
          icon="mdi-delete"
          color="red-8"
          class="q-ml-sm"
          @click.stop="$emit('delete', index)"
        >
          <q-tooltip>Delete</q-tooltip>
        </q-btn>
      </div>
    </q-item-section>
  </q-item>
</template>

<script>
import { doneOptionFor } from 'components/app/checklists/checklistDefinitions'

/*
  Read-only summary row for a checklist template item. Editing happens through
  the shared TaskStepper view (swapped in by the parent on @edit).
*/
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['edit', 'delete'],
  computed: {
    company () {
      return this.$store.getters['company/getCompany']
    },
    hasAnyRequirement () {
      return this.item.is_required ||
        this.item.requires_photo ||
        this.item.requires_invoice ||
        this.item.requires_quotation ||
        (this.item.required_forms || []).length > 0
    },
    invoiceChipLabel () {
      const option = doneOptionFor('invoice', this.company.checklist_invoice_done_when)
      return option.value === 'FINALISED' ? 'Invoice' : `Invoice (${option.label.toLowerCase()})`
    },
    quotationChipLabel () {
      const option = doneOptionFor('quotation', this.company.checklist_quotation_done_when)
      return option.value === 'FINALISED' ? 'Quote' : `Quote (${option.label.toLowerCase()})`
    },
    errorMessage () {
      const firstKey = Object.keys(this.errors)[0]
      return firstKey ? this.errors[firstKey][0] : null
    }
  }
}
</script>
